// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","198":"board","787":"sponsor"}[chunkId] + "." + {"177":"d6c7b94f","198":"26632852","787":"73816411"}[chunkId] + ".css";
};